import { ReservationStatusEnum, ReservationStoreStatusEnum } from '../../../core/enums/reservation/reservation';

export const getReservationStoreStatusOptions = [
    {
        value: ReservationStoreStatusEnum.READY_FOR_REALIZATION.value,
        label: ReservationStoreStatusEnum.READY_FOR_REALIZATION.label
    },
    {
        value: ReservationStoreStatusEnum.ERROR_IN_RESERVATION.value,
        label: ReservationStoreStatusEnum.ERROR_IN_RESERVATION.label
    },
    { value: ReservationStoreStatusEnum.IN_PROGRESS.value, label: ReservationStoreStatusEnum.IN_PROGRESS.label },
    {
        value: ReservationStoreStatusEnum.PREPARED_DELIVERY.value,
        label: ReservationStoreStatusEnum.PREPARED_DELIVERY.label
    },
    { value: ReservationStoreStatusEnum.COMPLETED.value, label: ReservationStoreStatusEnum.COMPLETED.label }
];

export const getReservationStatusOptions = [
    { value: ReservationStatusEnum.NEW.value, label: ReservationStatusEnum.NEW.label },
    { value: ReservationStatusEnum.CANCELED_BY_STORE.value, label: ReservationStatusEnum.CANCELED_BY_STORE.label },
    {
        value: ReservationStatusEnum.CANCELED_BY_CUSTOMER.value,
        label: ReservationStatusEnum.CANCELED_BY_CUSTOMER.label
    },
    { value: ReservationStatusEnum.WAITING_FOR_PAYMENT.value, label: ReservationStatusEnum.WAITING_FOR_PAYMENT.label },
    { value: ReservationStatusEnum.PAID.value, label: ReservationStatusEnum.PAID.label },
    { value: ReservationStatusEnum.UNPAID.value, label: ReservationStatusEnum.UNPAID.label },
    { value: ReservationStatusEnum.DELIVERED.value, label: ReservationStatusEnum.DELIVERED.label },
    { value: ReservationStatusEnum.PREPARED.value, label: ReservationStatusEnum.PREPARED.label },
    { value: ReservationStatusEnum.FINISHED.value, label: ReservationStatusEnum.FINISHED.label },
    { value: ReservationStatusEnum.PARTIALLY_RETURNED.value, label: ReservationStatusEnum.PARTIALLY_RETURNED.label },
    { value: ReservationStatusEnum.RETURNED.value, label: ReservationStatusEnum.RETURNED.label },
];

export const getReservationStatusColor = (status) => {
    switch (status) {
        case ReservationStatusEnum.WAITING_FOR_PAYMENT.value:
            return 'default';
        case ReservationStatusEnum.PAID.value:
            return 'secondary';
        case ReservationStatusEnum.PREPARED.value:
            return 'info';
        case ReservationStatusEnum.DELIVERED.value:
        case ReservationStatusEnum.FINISHED.value:
            return 'success';
        case ReservationStatusEnum.CANCELED_BY_STORE.value:
        case ReservationStatusEnum.CANCELED_BY_CUSTOMER.value:
        case ReservationStatusEnum.PARTIALLY_RETURNED.value:
        case ReservationStatusEnum.RETURNED.value:
            return 'warning';
        case ReservationStatusEnum.UNPAID.value:
            return 'error';
        default:
            return 'none';
    }
};